import request from './request';

const trackGoal = async eventId => {
  if (eventId === undefined) return;

  try {
    await request(`/api/v2/tracker/goal`, {
      method: 'POST',
      body: JSON.stringify({
        eventId,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
    });
  } catch (ex) { }  // eslint-disable-line
};

export default trackGoal;
